export enum frequencyType {
  ONE_TIME = '1T',
  DAILY = 1,
  WEEKLY = 7,
  EVERY_OTHER_WEEK = 14,
  MONTHLY = 30,
  EVERY_OTHER_MONTH = 60,
  QUARTERLY = 90,
}
export enum MOSACIKING {
  STITCHED = 'stitched',
  UNSTITCHED = 'unstitched',
}
